// A hood state changes the garment's visible components, never its equipment slot or look.
export const HOOD_STATES = Object.freeze(['up', 'down']);

// Catalog controls need the same authoring fact before fetching the fitted GLB.
// These are look identities, never pinned fitting URLs or owner verdicts.
export const HOODED_LOOK_DEFAULTS = Object.freeze({
  '8FF95EFB-46B9-B110-DA23-C661DC053F1A': 'down',
  '53C85513-6E18-6A6A-63F6-0207C2D1B835': 'down',
  '4A40D26B-3198-3F8B-1185-0B2C15616D94': 'down',
  '8D69EAA2-3A36-2FB0-165C-BA695F38B52B': 'down',
  '27D880EC-F3B4-6B46-1C57-840D0EFFEA46': 'down',
  '0FC22756-BB3B-8A40-6FE5-B3FDEDC9EC22': 'down',
  'D711A1D0-09E3-24C1-BEAE-54FA2EF63500': 'up',
  '05BAE0F0-09A3-8AFD-305E-C616094FA036': 'up',
  'A5785461-EFE5-7CE3-3F50-7D9DCC7C8B04': 'up',
  '932D8DC8-3365-CB3A-BE9C-5BA2F8A4D65A': 'up',
  'F1BD1C82-6D75-626D-7537-3A5C44BD249D': 'up',
  '7B1636AE-9AD4-91EB-A45F-00AA7A3438D1': 'up',
  '5E6079C8-9A98-B6C2-24C7-AD7E15BB7070': 'up',
  '719C037F-6301-B15D-A7F2-744C97E6EF7A': 'up',
  '614F03F5-3979-BFA1-A4A9-195AB5F2099B': 'up',
  '1CB06DAD-ECEC-ACB4-A612-8E34D0BA3843': 'up',
});

export function hoodLookDefault(lookId) {
  return HOODED_LOOK_DEFAULTS[String(lookId ?? '').toUpperCase()] ?? null;
}

export function hoodPartState(mesh) {
  const value = mesh?.userData?.ft_hood_state;
  return HOOD_STATES.includes(value) ? value : null;
}

export function isHoodGarment(mesh) {
  return hoodPartState(mesh) !== null || mesh?.userData?.ft_hood_garment === true;
}

export function hoodState(appearance) {
  const value = appearance?.equipmentVisibility?.hoodState;
  return HOOD_STATES.includes(value) ? value : null;
}

export function defaultHoodState(meshes) {
  return meshes.find(mesh => HOOD_STATES.includes(mesh?.userData?.ft_hood_default_state))
    ?.userData.ft_hood_default_state ?? 'up';
}

export function hasHoodStates(meshes) {
  return HOOD_STATES.every(state => meshes.some(mesh => hoodPartState(mesh) === state));
}

export function hoodComponentVisible(mesh, state = null, fallback = 'up') {
  const part = hoodPartState(mesh);
  const authoredDefault = mesh?.userData?.ft_hood_default_state;
  return part === null || part === (HOOD_STATES.includes(state) ? state
    : HOOD_STATES.includes(authoredDefault) ? authoredDefault : fallback);
}

export function drawnHoodRaised(meshes) {
  return meshes.some(mesh => {
    if (hoodPartState(mesh) !== 'up') return false;
    for (let node = mesh; node; node = node.parent) if (node.visible === false) return false;
    return true;
  });
}
